import { Component, ElementRef, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BfxAppStatusService } from "../bfx-common/services/bfx-app-status.service";
import {
  BfxUserSettingsPageComponent,
  BfxUserSettingsValidityState,
} from "./bfx-user-settings-page.component";
import { BfxUserSettingsService } from "./bfx-user-settings.service";

// BFX
import { LoggerService } from "@bfx/logger";
import {
  ProfileUpdateRequestImpl,
  SystemControlImpl,
  SystemControlStatus,
  SystemControlSubType,
} from "shared/cubiq-model-multi-asset";
import {
  ProfilePromiseActionService,
  SystemConfigPromiseService,
  SystemControlPromiseLookupService,
  UserPromiseLookupService,
} from "shared/cubiq-services";
const logger = LoggerService.for(__dirname);

@Component({
  selector: ".bfx-panic-controls-settings",
  templateUrl: "./html/bfx-panic-controls-settings.html",
  standalone: false,
})
export class BfxPanicControlsComponent extends BfxUserSettingsPageComponent implements OnDestroy {
  private _activeTab: number = 0;
  public ready: boolean = false;

  public activeSubComponent: number = 5;
  public panicControl: any = {
    autoFill: null,
    panicOrderBook: null,
    panicOrderMonitoring: null,
    orderBookChangesToggle: false,
    orderMonitoringToggle: false,
    orderAutoFillToggle: false,
  };

  constructor(
    public userSettingsService: BfxUserSettingsService,
    public systemConfigService: SystemConfigPromiseService,
    public profileService: ProfilePromiseActionService,
    public userService: UserPromiseLookupService,
    public systemContolPromiseService: SystemControlPromiseLookupService,
    public element: ElementRef,
    public translationService: TranslateService,
    private appStatusService: BfxAppStatusService,
  ) {
    super();
  }

  public onTabActivated(event: any): void {}

  public initialize(): void {
    this.activeSubComponent = this.parentComponent.activeSubCategory;

    this.checkAutoFillChangesStatus();
    this.checkOrderBookChangesStatus();
    this.checkOrderMonitoringStatus();
    setTimeout(() => {
      this.ready = true;
    }, 100);
  }

  public validate(): Promise<BfxUserSettingsValidityState> {
    return new Promise<BfxUserSettingsValidityState>((res, reject) => {
      let state = BfxUserSettingsValidityState.VALID;
      //logger.out.info(`${this.constructor.name}.validate() valid:BfxUserSettingsValidityState.${BfxUserSettingsValidityState[state]}`);
      res(state);
    });
  }

  public reset(): Promise<void> {
    return new Promise<void>((res, reject) => {
      res();
    });
  }

  public save(request: ProfileUpdateRequestImpl): void {}

  public postReset(): void {}

  public postSave(request: ProfileUpdateRequestImpl): void {}

  public orderAutoFillToggleChanged(autoFillChangesEvent): void {
    this.panicControl.autoFill = new SystemControlImpl();

    if (typeof autoFillChangesEvent === "boolean" && autoFillChangesEvent === true) {
      this.panicControl.autoFill.systemControlStatus = SystemControlStatus.OFFLINE;
      this.panicControl.autoFill.systemControlSubType = SystemControlSubType.AUTO_ORDER_PANIC;
    } else {
      this.panicControl.autoFill.systemControlStatus = SystemControlStatus.ONLINE;
      this.panicControl.autoFill.systemControlSubType = SystemControlSubType.AUTO_ORDER_PANIC;
    }

    this.systemContolPromiseService.setSystemStatus(this.panicControl.autoFill);
    this.appStatusService.changeStatus(this.panicControl.autoFill);

    this.checkAutoFillChangesStatus();
  }

  public orderBookChangesToggleChanged(orderBookChangesEvent): void {
    this.panicControl.panicOrderBook = new SystemControlImpl();

    if (typeof orderBookChangesEvent === "boolean" && orderBookChangesEvent === true) {
      this.panicControl.panicOrderBook.systemControlStatus = SystemControlStatus.OFFLINE;
      this.panicControl.panicOrderBook.systemControlSubType =
        SystemControlSubType.ORDERMONITOR_CHANGE_PANIC;
    } else {
      this.panicControl.panicOrderBook.systemControlStatus = SystemControlStatus.ONLINE;
      this.panicControl.panicOrderBook.systemControlSubType =
        SystemControlSubType.ORDERMONITOR_CHANGE_PANIC;
    }

    this.systemContolPromiseService.setSystemStatus(this.panicControl.panicOrderBook);
    this.appStatusService.changeStatus(this.panicControl.panicOrderBook);

    this.checkOrderBookChangesStatus();
  }

  public orderMonitoringToggleChanged(orderMonitoringEvent): void {
    this.panicControl.panicOrderMonitoring = new SystemControlImpl();

    if (typeof orderMonitoringEvent === "boolean" && orderMonitoringEvent === true) {
      this.panicControl.panicOrderMonitoring.systemControlStatus = SystemControlStatus.OFFLINE;
      this.panicControl.panicOrderMonitoring.systemControlSubType =
        SystemControlSubType.ORDERMONITOR_FEED_PANIC;
    } else {
      this.panicControl.panicOrderMonitoring.systemControlStatus = SystemControlStatus.ONLINE;
      this.panicControl.panicOrderMonitoring.systemControlSubType =
        SystemControlSubType.ORDERMONITOR_FEED_PANIC;
    }

    this.systemContolPromiseService.setSystemStatus(this.panicControl.panicOrderMonitoring);
    this.appStatusService.changeStatus(this.panicControl.panicOrderMonitoring);

    this.checkOrderMonitoringStatus();
  }

  private checkAutoFillChangesStatus() {
    this.appStatusService.castChange.subscribe((toggleAutoFillChanges: SystemControlImpl[]) => {
      if (!Array.isArray(toggleAutoFillChanges) || toggleAutoFillChanges.length != 0) {
        if (
          toggleAutoFillChanges.find(
            (item) =>
              item.systemControlStatus === SystemControlStatus.OFFLINE &&
              item.systemControlSubType === SystemControlSubType.AUTO_ORDER_PANIC,
          )
        ) {
          this.panicControl.orderAutoFillToggle = true;
        } else {
          this.panicControl.orderAutoFillToggle = false;
        }
      } else {
        this.panicControl.orderAutoFillToggle = false;
      }
    });
  }

  private checkOrderBookChangesStatus() {
    this.appStatusService.castChange.subscribe((togglePanicBookChanges: SystemControlImpl[]) => {
      if (!Array.isArray(togglePanicBookChanges) || togglePanicBookChanges.length != 0) {
        if (
          togglePanicBookChanges.find(
            (item) =>
              item.systemControlStatus === SystemControlStatus.OFFLINE &&
              item.systemControlSubType === SystemControlSubType.ORDERMONITOR_CHANGE_PANIC,
          )
        ) {
          this.panicControl.orderBookChangesToggle = true;
        } else {
          this.panicControl.orderBookChangesToggle = false;
        }
      } else {
        this.panicControl.orderBookChangesToggle = false;
      }
    });
  }

  private checkOrderMonitoringStatus() {
    this.appStatusService.castChange.subscribe((togglePanicMonitoring: SystemControlImpl[]) => {
      if (!Array.isArray(togglePanicMonitoring) || togglePanicMonitoring.length != 0) {
        if (
          togglePanicMonitoring.find(
            (item) =>
              item.systemControlStatus === SystemControlStatus.OFFLINE &&
              item.systemControlSubType === SystemControlSubType.ORDERMONITOR_FEED_PANIC,
          )
        ) {
          this.panicControl.orderMonitoringToggle = true;
        } else {
          this.panicControl.orderMonitoringToggle = false;
        }
      } else {
        this.panicControl.orderMonitoringToggle = false;
      }
    });
  }

  ngOnDestroy(): void {}
}
